import axios from './_nestAxios'

export const obtenerxIdAsEdicion = _id => axios.get(`/talleres/${_id}`)

export const obtenerxIdAsSoloLectura = _id =>
  axios.get(`/talleres/${_id}`, {
    params: {
      tipoConsulta: 'solo-lectura'
    }
  })

export const obtenerxIdAsTitulo = _id => axios.get(`/talleres/${_id}/titulo`)

export const nuevo = data => axios.post('/talleres', data)

export const actualizarxId = (_id, data) => axios.put(`/talleres/${_id}`, data)
